import { AsyncSelectInputSingle } from '@frontend/basic-forms';

import useRakindaSelect from './rakinda-select.controller';

const ID = 'rakinda-select';
export interface RakindaSelectProps {
    id?: string;
    required?: boolean;
    submitted: boolean;
    onChange: (newValue?: string) => void;
    value?: string;
    className?: string;
    disabled?: boolean;
    label?: React.ReactNode;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
}

const RakindaSelect = (props: RakindaSelectProps) => {
    const viewProps = useRakindaSelect(props);

    return (
        <AsyncSelectInputSingle
            id={props.id || ID}
            label={props.label || 'Rakinda'}
            className={props.className}
            submitted={props.submitted}
            required={props.required}
            options={viewProps.options}
            onChange={(newValue) => props.onChange(newValue?.value)}
            value={viewProps.value?.value}
            isDisabled={props.disabled}
            onMenuScrollToBottom={viewProps.onScrollToBottom}
            loadOptions={viewProps.search}
            isClearable={props.isClearable}
            useConditionedStyling={props.useConditionedStyling}
        />
    );
};

export default RakindaSelect;
